module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/modelli_manutenzione-15b61385e428d68883d7d8466bcc9daa.png";